export const routes = {
  initial: "/",
  food: "/food",
};
